import { useState } from "react";

export default function useTransfertPanier() {
  const [panier, setPanier] = useState([]);

  const saveDocument = (doc) => {
    console.log("Panier Saved ! ", panier)
    setPanier(prev => {
      const exist = prev.find(p => p.sourceDocumentId === doc.sourceDocumentId);
      if (exist) {
        return prev.map(p =>
          p.sourceDocumentId === doc.sourceDocumentId ? doc : p
        );
      }
      return [...prev, doc];
    });
  };

  const clearPanier = () => setPanier([]);

  return { panier, saveDocument, clearPanier };
}